/**
 * @generated SignedSource<<bf839f40a51569ed525c72ce1141a731>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckIsVideoContent$data = {
  readonly __typename: string;
  readonly " $fragmentType": "helpersCheckIsVideoContent";
};
export type helpersCheckIsVideoContent$key = {
  readonly " $data"?: helpersCheckIsVideoContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsVideoContent">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckIsVideoContent"
};

(node as any).hash = "490675bb725722587ab9c02fea964e57";

export default node;
